// fingerprintjs2 (~59 KiB) só é baixado quando o fingerprint é pedido, fora do bundle de entrada.
const getDeviceFingerprint = () =>
  import("fingerprintjs2").then(
    ({ default: Fingerprint2 }) =>
      new Promise(resolve => {
        Fingerprint2.get(components => {
          const result = Fingerprint2.x64hash128(components.map(pair => pair.value).join(), 31);

          resolve(result);
        });
      })
  );

export { getDeviceFingerprint };
